var adjRSlideshow
function setupAdjustableRound(){
	adjRound = {}

	adjRSlideshow = $('.adjr-slideshow').slideshow()
	interactiveKeyboard = $('.adjr-interactive-keyboard').interactiveKeyboard('adjustableRoundKeys')

	var screen1 = adjRSlideshow.getScreen(1)
	setupIntroScreen(screen1, adjRSlideshow, interactiveKeyboard)

	var screen2 = adjRSlideshow.getScreen(2)
	setupChoosingGameType(screen2, adjRSlideshow)

	var screen3 = adjRSlideshow.getScreen(3)
	setupChoosingLetters(screen3, adjRSlideshow, interactiveKeyboard)

	var screen4 = adjRSlideshow.getScreen(4)
	setupChoosingDensity(screen4, adjRSlideshow)
	setupChoosingLength(screen4, adjRSlideshow)

	var screen5 = adjRSlideshow.getScreen(5)
	setupGameWindow(screen5, adjRSlideshow)

    adjRSlideshow.toggleScreen(1)
}

function getKeysForBackend(){
	var keys = ''
	var shiftEnabled = adjRound.keys.indexOf('shift') >= 0
	for (var i = 0; i < adjRound.keys.length; i++){
		var key = adjRound.keys[i]
		if (key !== 'shift') {
			key = addDiacritics(key)
			key = key
					.replace('comma', ',')
					.replace('dot', '.')
					.replace('question', '?')
					.replace('exclamation', '!')
					.replace('bracketleft', '(')
					.replace('bracketright', ')')
					.replace('quote', '"')
					.replace('at', '@')
					.replace('dash', '-')
					.replace('slash', '/')
					.replace('semicolon', ';')
					.replace('colon', ':')
			if (shiftEnabled && key !== key.toUpperCase() && 'áéíóúůěýřščžďťň'.indexOf(key) < 0) { //last condition is to eliminate letters we cannot handle in game (we don't have the option to catch capitals with diacritics yet)
				key += key.toUpperCase()
			}
			keys += key
		}
	}
	return keys
}

function setupIntroScreen(screen1, adjRSlideshow, interactiveKeyboard){
	if (typeof lastGameSettings !== 'undefined'){
		$('#lastGameSetting').click(function(){
            interactiveKeyboard.removeAllKeys()
			interactiveKeyboard.addKeys(lastGameSettings.letters)
			$('.game-' + lastGameSettings.type).click()
			$(['none', '.slow', '.standard-speed', '.fast'][lastGameSettings.gameSpeed]).click()
			$(['none', '.standard-length', '.long', '.extra-long'][lastGameSettings.gameLength]).click()
			adjRSlideshow.toggleScreen(5)
		})
	}

    adjRSlideshow.functionsOnShow[1] = function() {
        $(".settings-menu").find(".keys-header-cell, .keys-cell, .difficulty-cell, .difficulty-cell-pills").find(".content").removeClass("visible")
    }
}

function setupChoosingGameType(screen2, adjRSlideshow){
    adjRSlideshow.functionsOnShow[2] = function() {
        $(".settings-menu").find(".keys-header-cell, .keys-cell, .difficulty-cell, .difficulty-cell-pills").find(".content").removeClass("visible")
    }
	$('#gameType').click(function(){
		if (typeof adjRound.gameType !== 'undefined') adjRSlideshow.toggleScreen(2)
	})
	$('.game-type', screen2).click(function(){
		adjRound.gameType = $(this).data('gameid')
		$('.disp-game-type').addClass('hidden')
		$('.disp-game-type-' + adjRound.gameType).removeClass('hidden')
		$('.game-type', screen2).removeClass('green').addClass('gray')
		$(this).removeClass('gray').addClass('green')
	})
}

function setupChoosingLetters(screen3, adjRSlideshow, interactiveKeyboard){
	var displayKeysFunction = function(){
		var keys = interactiveKeyboard.keys

		keys = keys.reduce(function(obj, key) {
            if(key != addDiacritics(key))
                obj.diacritics.push(key)
			else if(key.length > 1)
				obj.special.push(key)
			else
				obj.simple.push(key)
			return obj
		}, {
			simple: [],
			diacritics: [],
			special: []
		})

		var flatten = function(keys) {
			keys.sort()
            return keys.join(' ')+' '
		}
		keys = flatten(keys.simple)+flatten(keys.diacritics)+flatten(keys.special)
		keys = keys.substr(0, keys.length-1)

		$('.disp-keys').text(addDiacritics(keys)
			.replace('comma', ',')
			.replace('dot', '.')
			.replace('question', '?')
			.replace('exclamation', '!')
			.replace('bracketleft', '(')
			.replace('bracketright', ')')
			.replace('quote', '"')
			.replace('at', '@')
			.replace('dash', '-')
			.replace('slash', '/')
			.replace('semicolon', ';')
            .replace('colon', ':')
            .replace('shift', 'SHIFT'))
		adjRound.keys = interactiveKeyboard.keys

        $('.keys-errors').addClass('hidden')
	}
	var checkAllOrNoneBoxes = function(){
		if (interactiveKeyboard.areAllKeysSelected())
			$('.all-keys-checkbox').addClass('active')
		else
			$('.all-keys-checkbox').removeClass('active')

		if (interactiveKeyboard.noKeysSelected())
			$('.no-keys-checkbox').addClass('active')
		else
			$('.no-keys-checkbox').removeClass('active')
	}
	interactiveKeyboard.onKeysChanged(function(){
		displayKeysFunction()
		checkAllOrNoneBoxes()
	})
	displayKeysFunction()
	checkAllOrNoneBoxes()

	adjRSlideshow.onScreenChanged(function(){
		if (adjRSlideshow.currentScreenId <= 3) $('.keys-cell').addClass('efi-out')
		else $('.keys-cell').removeClass('efi-out')
	})

	$('#chosenKeys').click(function(){
		if (typeof adjRound.keys !== 'undefined') adjRSlideshow.toggleScreen(3)
	})

    adjRSlideshow.functionsOnShow[3] = function() {
        displayKeysFunction()
        $(".settings-menu").find(".keys-header-cell, .keys-cell, .difficulty-cell, .difficulty-cell-pills").find(".content").removeClass("visible")
    }
	adjRSlideshow.functionsOnClose[3] = function(){

		var keys = getKeysForBackend()

		if(keys.length === 0) {
            $('.keys-errors').addClass('hidden')
            $('.noletters-error').removeClass('hidden')
            return false
		}

		if(keys.length < 2) {
            $('.keys-errors').addClass('hidden')
            $('.fewletters-error').removeClass('hidden')
            return false
		}

        /*if(adjRSlideshow.nextScreenId > adjRSlideshow.currentScreenId) {
            $.ajax({
                url: adjRoundSettings.checkKeysUrl,
                data: {
                    allowedLetters: keys
                },
                async: false,
                success: function (resp) {
                    if (!resp.hasWords) {
                        $('.keys-errors').addClass('hidden')
                        $('.fewwords-error').removeClass('hidden')
					}
                    else
                        adjRSlideshow.toggleScreen(adjRSlideshow.nextScreenId, true)
                }
            })
            return false
        }*/
        adjRSlideshow.toggleScreen(adjRSlideshow.nextScreenId, true)
	}
}

function setupChoosingDensity(screen4, adjRSlideshow){
    adjRSlideshow.functionsOnShow[4] = function(){
        $(".settings-menu").find(".keys-header-cell, .keys-cell").find(".content").addClass("visible")
        $(".settings-menu").find(".difficulty-cell, .difficulty-cell-pills").find(".content").removeClass("visible")
		if (adjRound.gameType == 3) {
			$('.density-choosing', screen4).addClass('hidden')
			$('.length-choosing', screen4).css({
				transform: 'translateY(-110px)'
			})
		}
		else{
			$('.density-choosing', screen4).removeClass('hidden')
			$('.length-choosing', screen4).css({
				transform: 'none'
			})
		}
	}

	var setGameDensity = function(t){
		adjRound.gameSpeed = t.data('speed')
		$('.slow, .standard-speed, .fast', screen4).removeClass('background-green').addClass('background-gray2')
		t.addClass('background-green').removeClass('background-gray2')
		var density
		if(t.hasClass('slow')) density = localizedTexts.dev.density1
		else if(t.hasClass('standard-speed')) density = localizedTexts.dev.density2
		else if(t.hasClass('fast')) density = localizedTexts.dev.density3
		$('.disp-game-speed').text(localizedTexts.dev.density + ' ' + density)
	}

	$('.slow, .standard-speed, .fast', screen4).click(function(){
		setGameDensity($(this))
	})
	setGameDensity($('.standard-speed', screen4))

	adjRSlideshow.onScreenChanged(function(){
		if(adjRSlideshow.currentScreenId <= 4) $('.disp-game-speed').addClass('efi-out')
		else $('.disp-game-speed').removeClass('efi-out')
	})

	$('.disp-game-speed').click(function(){
		if (adjRSlideshow.currentScreenId > 4) adjRSlideshow.toggleScreen(4)
	})
}

function setupChoosingLength(screen4, adjRSlideshow){
	var setGameLength = function(t){
		adjRound.gameLength = t.data('length')
		$('.standard-length, .long, .extra-long', screen4).removeClass('background-green').addClass('background-gray2')
		t.addClass('background-green').removeClass('background-gray2')
		var length
		if (t.hasClass('standard-length')) length = localizedTexts.dev.duration1
		else if (t.hasClass('long')) length = localizedTexts.dev.duration2
		else if (t.hasClass('extra-long')) length = localizedTexts.dev.duration3
		$('.disp-game-length').text(localizedTexts.dev.duration + ' ' + length)
	}

	$('.long, .standard-length, .extra-long', screen4).click(function(){
		setGameLength($(this))
	})

	setGameLength($('.standard-length', screen4))

	adjRSlideshow.onScreenChanged(function(){
		if(adjRSlideshow.currentScreenId <= 4) $('.disp-game-length').addClass('efi-out')
		else $('.disp-game-length').removeClass('efi-out')
	})

	$('.disp-game-length').click(function(){
		if (adjRSlideshow.currentScreenId > 4) adjRSlideshow.toggleScreen(4)
	})
}

function setupGameWindow(screen5, adjRSlideshow){
	adjRSlideshow.functionsOnShow[5] = function(){
        $(".settings-menu").find(".keys-header-cell, .keys-cell, .difficulty-cell, .difficulty-cell-pills").find(".content").addClass("visible")
		screen5.find('.spinner').removeClass('hidden')

		var params = $.param({
			gameTypeId: adjRound.gameType,
			chosenLetters: getKeysForBackend(),
			gameSpeed: adjRound.gameSpeed,
			gameLength: adjRound.gameLength,
		})

		$("#gameFrame").contents().find("body").html('');
		$('#gameFrame').attr('src', adjRoundSettings.gameUrl + (window.location.href.indexOf('?') >= 0 ? '&' : '?') + params)
	}

	adjRSlideshow.functionsOnClose[5] = function(){
		$(this).addClass('efi-out')
	}

	$('#gameFrame').on('load', function(){
		screen5.find('.spinner').addClass('hidden')
		$(this).removeClass('efi-out')
		$('#gameFrame')[0].contentWindow.focus()

		$('.game-window').css('border', 'none');
		$('.game-window').css('border-bottom', '2px solid #EEE');

		document.addEventListener('keydown', event => {
			const iframe = $("#gameFrame")[0];
			iframe.contentWindow.focus();
		})



	})
}